import { ActionResponse } from "../../domain/models/http/MutationsRequest";
import { ImportModel, ImportType } from "../../domain/models/Import";
import QueryService from "../QueryService";

class ImportMutationService extends QueryService<ImportModel> {
  public constructor(baseURL: string, pathname: string) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }

  public async uploadPaymentFile(
    file: File,
    type: ImportType,
  ): Promise<ImportModel | null> {
    const formData = new FormData();
    formData.append("fields[0][name]", "type");
    formData.append("fields[0][value]", type);
    formData.append("file", file);

    await this.api.post<ActionResponse>(
      `${this.pathname}/actions/import-payment-file`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    const response = await this.search({
      search: {
        filters: [
          { field: "original_filename", operator: "=", value: file.name },
        ],
        sorts: [{ field: "created_at", direction: "desc" }],
        limit: 10,
      },
    });

    return response.data[0] ?? null;
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const importMutationService = new ImportMutationService(BASE_URL, "imports");

export { importMutationService };
